import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupSendMsgAdminContentProps } from './msg-group-send-msg-admin-content';
import { MsgGroupSendMsgAdminContent } from './msg-group-send-msg-admin-content';

export interface MsgGroupSendMsgAdminPreviewProps extends MsgGroupSendMsgAdminContentProps {}

export const MsgGroupSendMsgAdminPreview = memo(function MsgGroupSendMsgAdminPreview({
  message,
}: MsgGroupSendMsgAdminPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupSendMsgAdminContent message={message} />
    </LastMessageSystem>
  );
});
